// `other` covers a channel the settings screen has no name or icon for, such as DP Chat.
export type TextChannelType = 'whatsapp' | 'sms' | 'other';

export class TextChannel {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly type: TextChannelType,
    readonly phoneNumber: string,
  ) {}
}
